var BOLD = BOLD || {};
BOLD.BMS = BOLD.BMS || {};
BOLD.BMS.TU = BOLD.BMS.TU || {};

BOLD.BMS.TU.Common = function($) {
    "use strict";
    
    function getQuantity(quantity, product) {
        let value = quantity.default;
            
        for(var i = 0; i < quantity.exceptions.length; i++) {
            let exception = quantity.exceptions[i];
            let current = exception.list.find(function(item) { return product.vendor.toLowerCase() === item.replace(/\s/g, "-").toLowerCase(); });
            
            if(current) {
                value = exception.default;
                break;
            }
        }

        return value;
    }

    return {
        getQuantity: getQuantity
    }

}(BOLD.jQuery || jQuery)